import { ArrayHelpers, FieldArray, FormikProps } from 'formik';
import React from 'react';

import { IRoomWithDevicesAndFwInfo } from '../interfaces/IOdooRoomsResponse';
import { DevicesUpdateFormValues } from '../pages/installation/wire/Devices';
import RoomHeater from './RoomHeater';

interface IRoomHeaterProps {
    roomWithDevices: IRoomWithDevicesAndFwInfo;
    index: number;
    deepomaticWorkOrderId: string | false | undefined;
    formRef?: React.RefObject<FormikProps<DevicesUpdateFormValues>>;
}

const RoomHeaters: React.FunctionComponent<IRoomHeaterProps> = ({
    roomWithDevices,
    index,
    deepomaticWorkOrderId,
    formRef,
}) => {
    const devices = roomWithDevices.devices;
    return (
        <FieldArray
            name="devices"
            render={(arrayHelpers: ArrayHelpers) => (
                <div className="ion-padding-bottom">
                    {devices &&
                        //@ts-ignore
                        devices?.map((device, i) => {
                            return (
                                <RoomHeater
                                    key={device.macAddress}
                                    index={index + i}
                                    device={device}
                                    room={roomWithDevices}
                                    deepomaticWorkOrderId={
                                        deepomaticWorkOrderId
                                    }
                                    formRef={formRef}
                                />
                            );
                        })}
                </div>
            )}
        />
    );
};

export default RoomHeaters;
